import {ChangeDetectionStrategy, Component, EventEmitter, inject, OnInit} from '@angular/core';
import {NbWindowService} from '@nebular/theme';
import {BaseFieldType, CatalogWithAncestors} from 'compob2b-libs';
import {EMPTY, Observable, of} from 'rxjs';
import {map, switchMap, take, takeUntil, tap} from 'rxjs/operators';
import {translations} from '../../../../environments/translations.ru';
import {ChooseCatalogModalComponent} from '../../choose-catalog-modal/choose-catalog-modal.component';
import {CatalogService} from '../../../cabinet/pim/catalog/catalog.service'

@Component({
  templateUrl: './catalog-picker.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: `[nbInput] { max-width: 800px }`,
  standalone: false
})
export class CatalogPickerComponent extends BaseFieldType implements OnInit {
  catalog: CatalogWithAncestors = null;
  catalogChosenEvent: EventEmitter<CatalogWithAncestors> = new EventEmitter<CatalogWithAncestors>();

  catalogService = inject(CatalogService);

  constructor(
    protected readonly windowService: NbWindowService,
  ) {
    super();
  }

  get excludeCatalogIds() {
    return this.props['excludeCatalogIds'] ?? [];
  }

  ngOnInit(): void {
    this.formControl.valueChanges
      .pipe(
        switchMap(id => this.getCatalogWithAncestorsByID(id)),
        takeUntil(this.unsubscribe),
      )
      .subscribe({
        next: (catalog) => {
          this.catalog = catalog;
          this.cdr.detectChanges();
        },
        error: (err) => {
          this.loading = false;
          this.cdr.detectChanges();
          console.error('CatalogPickerComponent FAILED', err);

          return null;
        },
      });

    this.catalogChosenEvent
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(catalog => this.select(catalog));
  }

  getCatalogWithAncestorsByID(catalogID: number): Observable<CatalogWithAncestors> {
    if (!catalogID) {
      return EMPTY;
    }

    if (this.catalog && this.catalog.id === catalogID) {
      return of(this.catalog);
    }

    this.loading = true;
    return this.compoApiService.get<CatalogWithAncestors>(`${this.catalogService.apiUrl}/${catalogID}/with-ancestors`)
      .pipe(
        take(1),
        map(response => response.data),
        tap(_ => this.loading = false)
      );
  }

  getOptionLabel(catalog: CatalogWithAncestors): string {
    return catalog ? catalog.ancestors.filter(item => item !== null).concat(catalog.header).join(' > ') : '';
  }

  openChooseCatalogModal(): void {
    this.formControl.markAsTouched();

    this.windowService.open(ChooseCatalogModalComponent, {
      context: {
        catalogService: this.catalogService,
        onlyOneSelection: true,
        catalogChosenEvent: this.catalogChosenEvent,
        chooseOnlyLastLevel: this.field.props.chooseOnlyLastLevel === undefined || this.field.props.chooseOnlyLastLevel,
        chosenCatalog: this.catalog,
        excludeCatalogIds: this.excludeCatalogIds,
      },
      title: translations.selectOneCatalog
    });
  }

  select(chosenCatalog: CatalogWithAncestors | null) {
    this.formControl.setValue(chosenCatalog ? chosenCatalog.id : (this.field?.defaultValue || null));
    this.formControl.markAsTouched();
    this.cdr.detectChanges();
  }

}
